// F1 Breadcrumb Component
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const F1Breadcrumb = ({ currentPage }) => {
  const location = useLocation();
  
  // Generate breadcrumb items based on URL path
  const generateBreadcrumbItems = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const breadcrumbItems = [];
    
    // Always start with F1 base
    breadcrumbItems.push({ name: 'F1', path: '/f1' });
    
    // Handle different F1 routes
    if (pathSegments.length >= 2 && pathSegments[0] === 'f1') {
      const f1Segment = pathSegments[1];
      
      // Helper to convert URL segment to title case
      const toTitleCase = (str) => {
        return str
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
      };
      
      // Special cases that need custom handling
      if (f1Segment === 'drivers' && pathSegments.length === 3) {
        breadcrumbItems.push({ name: 'Drivers', path: '/f1/drivers' });
        breadcrumbItems.push({ name: currentPage, path: location.pathname });
      } else if (f1Segment === 'circuits' && pathSegments.length === 3) {
        breadcrumbItems.push({ name: 'Circuits', path: '/f1/circuits' });
        breadcrumbItems.push({ name: currentPage, path: location.pathname });
      } else if (f1Segment === 'races' && pathSegments.length === 3) {
        breadcrumbItems.push({ name: 'Races', path: '/f1/races' });
        breadcrumbItems.push({ name: currentPage, path: location.pathname });
      } else if (f1Segment === 'seasons') {
        if (pathSegments.length === 2) {
          breadcrumbItems.push({ name: 'Seasons', path: '/f1/seasons' });
        } else if (pathSegments.length === 3) {
          const yearMatch = currentPage.match(/\d{4}/);
          const year = yearMatch ? yearMatch[0] : '';
          breadcrumbItems.push({ name: 'Seasons', path: '/f1/seasons' });
          breadcrumbItems.push({ name: `${year} Season`, path: location.pathname });
        } else if (pathSegments.length > 3) {
          const yearMatch = currentPage.match(/\d{4}/);
          const year = yearMatch ? yearMatch[0] : '';
          breadcrumbItems.push({ name: 'Seasons', path: '/f1/seasons' });
          breadcrumbItems.push({ name: `${year}`, path: `/f1/seasons/${year}` });
          breadcrumbItems.push({ name: currentPage, path: location.pathname });
        }
      } else if (f1Segment === 'explore') {
        breadcrumbItems.push({ name: 'Explore', path: '/f1' });
      } else {
        // Default: convert URL segment to title case
        breadcrumbItems.push({ name: toTitleCase(f1Segment), path: `/f1/${f1Segment}` });
      }
    }
    
    return breadcrumbItems;
  };
  
  const breadcrumbItems = generateBreadcrumbItems();

  return (
    <nav className="theme-bg shadow-sm p-4 mb-6 " aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2 text-sm max-w-7xl mx-auto">
        {breadcrumbItems.map((item, index) => (
          <li key={item.name} className="flex items-center">
            {index === breadcrumbItems.length - 1 ? (
              <span className="theme-primary font-medium">
                <span>{index === 0 ? '🏁' : ' › '}</span><span className="px-1">{item.name}</span>
              </span>
            ) : (
              <Link
                to={item.path}
                className="theme-secondary hover:theme-primary transition-colors"
              >
                <span>{index === 0 ? '🏁' : ' › '}</span><span className="px-1">{item.name}</span>
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default F1Breadcrumb;
